import React from 'react';
import { Outlet, useLocation } from 'react-router-dom'; // <-- 1. IMPORT useLocation
import Header from './Header';
import Sidebar from './Sidebar';

// This component holds the persistent parts of your UI
export default function Layout({ toggleTheme, currentTheme }) {
  // 2. GET THE CURRENT LOCATION
  const location = useLocation();
  
  // 3. CHECK IF THE CURRENT PATH IS '/contact'
  const isContactPage = location.pathname === '/contact';

  return (
    // 4. ADD A CONDITIONAL CLASS TO THE WRAPPER
    <div className={`main-wrapper ${isContactPage ? 'no-sidebar' : ''}`}>
      <Header toggleTheme={toggleTheme} currentTheme={currentTheme} />
      
      {/* 5. ONLY RENDER SIDEBAR IF IT'S NOT THE CONTACT PAGE */}
      {!isContactPage && <Sidebar />}
      
      {/* Outlet is a placeholder. 
          React Router will render your page (Home, Services, etc.) here. */}
      <Outlet />
    </div>
  );
}